import { Autocomplete, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"

const AutoCompleteMoradores = ({ defaultValue = "", condominio, disableByOtherComp = false, disabled = false, callback, imoveisSelecionado = false, index = false, reset = false }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [searchText, setSearchText] = useState('')
    const [selectedValue, setSelectedValue] = useState(null)

    const [moradores, setMoradores] = useState([])

    const [buscou, setBuscou] = useState(false)

    const [moradoresPesquisados, setMoradoresPesquisados] = useState([])

    const getMoradores = (msg) => {
        const moradoresBack = msg.data.moradores.map((morador) => {
            const nome = morador.NOME || morador.nome || ''
            const cd_acesso = morador.cd_acesso || ''
            return { nome, cd_acesso }
        })

        setBuscou(true)
        setMoradores(moradoresBack)
        setMoradoresPesquisados(moradoresBack)
    }

    useEffect(() => {
        if (reset) {
            setSearchText('')
            setSelectedValue(null)
            setMoradores([])
            setMoradoresPesquisados([])
            let result = { target: { type: 'outro', value: '', name: 'morador' } }
            callback(result)
        }
    }, [reset])

    // Inicia o valor quando defaultValue é passado
    useEffect(() => {
        if (defaultValue && typeof defaultValue === 'string' && defaultValue.trim() !== '') {
            const initialValue = { nome: defaultValue, cd_acesso: '' }
            setSelectedValue(initialValue)
            setSearchText(defaultValue)
        }
    }, [defaultValue])

    useEffect(() => {
        // Não fazer requisições se já temos um valor selecionado e não está sendo digitado
        if (selectedValue && searchText === selectedValue.nome) {
            return
        }

        if (imoveisSelecionado.length > 0) {
            if ((index == false || index == undefined) && index !== 0) {
                const id_imovel = imoveisSelecionado[0].id_imovel
                addRoute("getMoradorByImovel", getMoradores)
                sendWs("getMoradorByImovel", { id_central: condominio, id_imovel })
            } else {
                const imovelSelecionado = imoveisSelecionado.find((imovel) => imovel.index === index)
                if (imovelSelecionado) {
                    const id_imovel = imovelSelecionado.id_imovel
                    addRoute("getMoradorByImovel", getMoradores)
                    sendWs("getMoradorByImovel", { id_central: condominio, id_imovel })
                }
            }
        } else if (searchText.length > 2) {
            if (moradoresPesquisados.length > 0) {
                let morador = moradoresPesquisados.filter(m => m.nome.toLowerCase().includes(searchText.toLowerCase()));

                if (morador.length > 0) {
                    let result = morador.map(m => ({
                        nome: m.nome || '',
                        cd_acesso: m.cd_acesso || ''
                    }))
                    setMoradores(result)
                } else {
                    setMoradores([])
                    setMoradoresPesquisados([])
                    let result = {
                        target: {
                            type: 'outro',
                            value: '',
                            name: 'morador'
                        }
                    }
                    callback(result)
                }
            } else if (imoveisSelecionado.length == 0 || !imoveisSelecionado) {
                addRoute("buscarTodosMoradores", getMoradores)
                sendWs("buscarTodosMoradores", { nome: searchText, id_central: condominio })
            }
        } else if (imoveisSelecionado.length == 0 || !imoveisSelecionado) {
            setMoradores([])
            setMoradoresPesquisados([])
            setBuscou(false)
            let result = {
                target: {
                    type: 'outro',
                    value: '',
                    name: 'morador'
                }
            }

            callback(result)
        }
    }, [searchText, imoveisSelecionado, selectedValue])

    const handleChangeInput = (event) => {
        setSearchText(event)
    }

    return (
        <Grid item xs={12}>
            <Autocomplete
                key={reset ? 'reset' : 'default'}
                options={moradores || []}
                getOptionLabel={(option) => option.nome || option}
                noOptionsText={buscou ? "Nenhum morador encontrado nesse imóvel" : "Digite pelo menos 3 letras e aguarde"}
                value={selectedValue}
                renderOption={(props, option) => (
                    <li {...props} key={option.cd_acesso}>  {/* use cd_acesso que é único */}
                        {option.nome}
                    </li>
                )}
                disabled={disabled || disableByOtherComp}
                inputValue={searchText}
                isOptionEqualToValue={(option, value) => {
                    if (!option || !value) { return false }

                    if (value.cd_acesso === '' && option.nome === value.nome) {
                        return true
                    }
                    return option.cd_acesso === value.cd_acesso && option.nome === value.nome
                }}
                sx={{
                    '& input': {
                        border: 'none',
                        width: '100%',
                        bgcolor: (disabled || disableByOtherComp) ? '#c9c7c7' : 'background.paper',
                        color: (theme) =>
                            theme.palette.getContrastText(theme.palette.background.paper)
                    },
                    '& fieldset': {
                        border: 'none'
                    }
                }}
                onChange={(event, newValue) => {
                    setSelectedValue(newValue)
                    if (newValue) {
                        setSearchText(newValue.nome)
                    }
                    let result = {
                        target: {
                            type: 'outro',
                            value: newValue?.nome || '',
                            name: 'morador',
                            index,
                            cd_acesso: newValue?.cd_acesso || ''
                        }
                    }
                    callback(result)
                }}
                onInputChange={(event, newInputValue) => {
                    handleChangeInput(newInputValue)
                }}
                renderInput={(params) => {
                    return (
                        <div data-index={`div-${index}`} style={{ width: '100%' }} ref={params.InputProps.ref}>
                            <input
                                placeholder={disabled ? "Selecione um condomínio" : "Digite pelo menos 3 letras e aguarde"}
                                style={{ width: '100%', height: '30px', borderRadius: '5px' }}
                                {...params.inputProps}
                            />
                        </div>

                    )
                }}
            />
        </Grid>
    )
}

export default AutoCompleteMoradores
